import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import PriceOneField from './fileds/PriceOneField'
import PriceGeneralField from './fileds/PriceGeneralField'
import CurrencySelectMain from '../../../../form/fields/CurrencySelectMain'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { editSupplyBillItemPriceAPI } from '../../../../../api/supply/supplyBillItemAPI'
import { useDispatch } from 'react-redux'
import { editSupplyBillItem } from '../../../../../store/supplyBillSlice'
import PdvSelectMain from '../../../../form/fields/PdvSelectMain'

const ChangePriceBillItemForm = ({ supplyBillItemBd, setOpen }) => {

    const dispatch = useDispatch()

    const [data, setData] = useState(
        supplyBillItemBd ? 
            {
                priceOne: supplyBillItemBd.priceOne,
                priceGeneral: supplyBillItemBd.priceGeneral,
                currency: supplyBillItemBd.currency ? supplyBillItemBd.currency : 'UAH',
                pdvType: supplyBillItemBd.pdvType,
            } 
        : {}
    ) // Дані з форми

    // console.log('data', data)
        
    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [loading, setLoading] = useState(false)

    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
    const [result, setResult] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    const save = (e) => {
        e.preventDefault()
        const dataForBd = getDataForBd()

        setError('')
        setLoading(true)

        editSupplyBillItemPriceAPI(dataForBd).then(data => {
            if (data) {
                dispatch(editSupplyBillItem(data))
            }

            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const changePriceOne = () => {
        const price = data.priceGeneral ? data.priceGeneral.replace(',', '.') : 0
        let priceOne = 0

        if (price && supplyBillItemBd.count) {
            priceOne = (price / supplyBillItemBd.count).toFixed(2)
            // priceOne = (price / supplyBillItemBd.count).toFixed(0)
        }

        setValueForm(setData, 'priceOne', priceOne)
    }

    const changePriceGeneral = () => {
        const price = data.priceOne ? data.priceOne.replace(',', '.') : 0
        let priceGeneral = 0

        if (price && supplyBillItemBd.count) {
            priceGeneral = (price * supplyBillItemBd.count).toFixed(2)
            // priceGeneral = (price * supplyBillItemBd.count).toFixed(0)
        }

        setValueForm(setData, 'priceGeneral', priceGeneral)
    }

    const getDataForBd = () => {
        const dataForBd = {
            id: supplyBillItemBd.id,
            priceOne: data.priceOne,
            priceGeneral: data.priceGeneral,
            currency: data.currency,
            pdvType: data.pdvType,
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
			formDataProductIsField('priceOne', 'supplyBillItemPriceForm') ?
				<PriceOneField
					required={formDataProductRequiredField('priceOne', 'supplyBillItemPriceForm')}
					setValidate={e => updateValidate(setValid, 'priceOne', e)}
					setValueForm={e => {
                        setValueForm(setData, 'priceOne', e)
                        // changePriceGeneral(e)
                    }}
					forciblyValue={data && data.priceOne ? data.priceOne : ''}
                    onBlurMy={e => {
                        // console.log('onBlurMy', e)
                        changePriceGeneral()
                    }}
				/>
			: ''
        }
        {
			formDataProductIsField('priceGeneral', 'supplyBillItemPriceForm') ?
				<PriceGeneralField
					required={formDataProductRequiredField('priceGeneral', 'supplyBillItemPriceForm')}
					setValidate={e => updateValidate(setValid, 'priceGeneral', e)}
					setValueForm={e => {
                        setValueForm(setData, 'priceGeneral', e)
                        // changePriceOne(e)
                    }}
					forciblyValue={data && data.priceGeneral ? data.priceGeneral : ''}
                    onBlurMy={e => {
                        // console.log('onBlurMy', e)
                        changePriceOne()
                    }}
				/>
			: ''
        }
        {
			formDataProductIsField('currency', 'supplyBillItemPriceForm') ?
				<CurrencySelectMain
					required={formDataProductRequiredField('currency', 'supplyBillItemPriceForm')}
					setValidate={e => updateValidate(setValid, 'currency', e)}
					setValueForm={e => setValueForm(setData, 'currency', e)}
					forciblyValue={data && data.currency ? data.currency : ''}
				/>
			: ''
        }
        {
			formDataProductIsField('pdvType', 'supplyBillItemPriceForm') ?
				<PdvSelectMain
					required={formDataProductRequiredField('pdvType', 'supplyBillItemPriceForm')}
					setValidate={e => updateValidate(setValid, 'pdvType', e)}
					setValueForm={e => setValueForm(setData, 'pdvType', e)}
					forciblyValue={data && data.pdvType ? data.pdvType : ''}
				/>
			: ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default ChangePriceBillItemForm